export const formNaming = {
  // New surveillance route form
  NEW_SURVEILLANCE_ROUTE_FORM: 'new-surveillance-route-form',

  // Edit surveillance route form
  EDIT_SURVEILLANCE_ROUTE_FORM: 'edit-surveillance-route-form',

  // Summary page form key
  SURVEILLANCE_ROUTE_SUMMARY_FORM: 'surveillance-route-summary-form',

  // Borrador de la tab Operarios del wizard "Nuevo recorrido" (NewRoute).
  // BUG borrador RV (2026-07-12): vivía solo en NewRoute/saveData.ts y el
  // logout (UserMenu) no lo purgaba — el borrador sobrevivía al deslogueo.
  // Al estar aquí entra en el bucle de limpieza de formularios base; sus
  // buckets con sufijo (_drivers/_interno/_externals) se limpian explícitos.
  NEW_SURVEILLANCE_ROUTE_OPERATORS_FORM: 'new-surveillance-route-operators',

  // Borrador de la tab Operarios del wizard "Editar recorrido" (EditRoute,
  // F4 2026-07-17). Key PROPIA para que el borrador de edición NO pise el de
  // creación (son flujos distintos que reusan el mismo wizard). La key base
  // entra en el bucle de purga en logout de `UserMenu/action.ts`
  // (`Object.values(surveillanceRouteFormNaming)`, igual que la NEW_); sus
  // buckets con sufijo (_drivers/_interno/_externals) se limpian explícitos
  // ahí mismo, espejo de los buckets de la NEW_.
  EDIT_SURVEILLANCE_ROUTE_OPERATORS_FORM: 'edit-surveillance-route-operators',
};
